var map = {
	"./banner-ads.webp": 2055,
	"./betting-contest.webp": 5120,
	"./blog.webp": 130,
	"./gachapon.webp": 8961,
	"./ico.webp": 1543,
	"./kol.webp": 9020,
	"./lending.webp": 8801,
	"./logo-icon.webp": 7049,
	"./lootbox-api.webp": 6260,
	"./marketplace-open-api.webp": 2197,
	"./marketplace.webp": 5373,
	"./polygon.webp": 4952,
	"./project-evaluation.webp": 7652,
	"./staking.webp": 4071,
	"./tournament.webp": 1349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7155;